import { useState } from 'react';
import './MarketComps.css';

function MarketComps({ comps, summary }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!comps || comps.length === 0) {
    return null;
  }

  return (
    <div className="market-comps">
      <button
        className="comps-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span>{isExpanded ? 'Hide' : 'View'} Market Comps</span>
        <span className="toggle-icon">{isExpanded ? '▲' : '▼'}</span>
      </button>

      <div className={`comps-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
        {/* Summary stats */}
        <div className="comps-summary">
          <div className="summary-stat">
            <span className="stat-label">Range:</span>
            <span className="stat-value">
              ${summary.min.toLocaleString()} - ${summary.max.toLocaleString()}
            </span>
          </div>
          <div className="summary-stat">
            <span className="stat-label">Median:</span>
            <span className="stat-value">${summary.median.toLocaleString()}</span>
          </div>
          <div className="summary-stat">
            <span className="stat-label">Sample:</span>
            <span className="stat-value">{summary.count} rentals</span>
          </div>
        </div>

        {/* Comps list */}
        <div className="comps-list">
          {comps.map((comp, index) => (
            <div
              key={index}
              className={`comp-item ${comp.isSimilar ? 'similar' : ''}`}
            >
              <div className="comp-rent">${comp.rent.toLocaleString()}</div>
              <div className="comp-details">
                <span>{comp.sqft} sqft</span>
                <span className="separator">•</span>
                <span>{comp.bathrooms} BA</span>
              </div>
              <div className="comp-features">{comp.features}</div>
              {comp.isSimilar && <span className="similar-badge">Similar</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MarketComps;
